import { AfterContentInit, Component, ContentChildren, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { CommonProgressStepComponent } from '../common-progress-step/common-progress-step.component';
import { Button, CurrentTab, Path, RoutePath } from '../../../model/enum';
import { Router } from '@angular/router';
import { TabsService } from '../../tabs/tabs.service';
import { ImportDocumentsService } from '../../../../components/import-documents/import-documents.service';
import { Menu } from '../../../services/nav.service';
import { SendDataService } from '../../../services/send-data.service';
import { ModalPopupSize } from '../../../model/common.model';
import { UnmappedPopUpComponent } from '../../unmapped-pop-up/unmapped-pop-up.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-common-step-progressbar',
  templateUrl: './common-step-progressbar.component.html',
  styleUrls: ['./common-step-progressbar.component.scss']
})
export class CommonStepProgressbarComponent implements OnInit ,AfterContentInit {
  @Output() stepChanged = new EventEmitter<string>();
  @Output() onNext = new EventEmitter<any>();

  @ContentChildren(CommonProgressStepComponent) activeSteps!: QueryList<CommonProgressStepComponent>;
  @ViewChild('progress', { static: true }) progressRef!: ElementRef<HTMLDivElement>;
 @Input() steps: string[] = [];
 @Input()  currentActive = 1;
 @Input()  currentTab :string ='';
isDisabled : boolean = false;
 enumButtonName = Button
   tabName = CurrentTab;
 @Input()  data:any ={}
 @Input() completedSteps: boolean[] = [];
 constructor( public router: Router, public tabsService: TabsService, public importDocumentsService: ImportDocumentsService, private sendDataService: SendDataService, private toaster: ToastrService) {
  this.tabsService.onSubNavChanged.subscribe((url=>{
    if(url!== undefined)
      this.currentActive = 2
      this.onPrevClick()
  }));
}
 
  ngAfterContentInit(): void {
    this.update();
    this.updateSteps();
  }
  ngOnInit(): void {
  }
  onPrevClick(): void {
    this.currentActive = Math.max(1, this.currentActive - 1);
    this.update();
    this.updateSteps();
    this.importDocumentsService.errorValidation.next(true);
    this.importDocumentsService.previuosTab.next(true);
    // this.stepChanged.emit(this.currentActive);
  }

  onNextClick(): void {
    this.currentActive = Math.min(this.steps.length, this.currentActive + 1);
    this.update();
    this.updateSteps();
  }
  onStepChange(step: string): void {
    this.stepChanged.emit(step);
  }
   update(): void {
    if (!this.progressRef || !this.progressRef.nativeElement) {
      return; 
    }
    const progressWidth = ((this.currentActive - 1) / (this.steps.length - 1)) * 100;
    this.progressRef.nativeElement.style.width = `${progressWidth}%`;
  }
  @Input() public set selectedIndex(value: number) {
    this.currentActive = value || 1;
    this.updateSteps();
  }

  updateSteps(): void {
    if (!this.activeSteps || this.activeSteps.length === 0) {
      return;
    }
    this.progressSteps.forEach((step, index) => {
      step.activeState = this.activeStep;
      step.stepIndex = index + 1; 
      step.completed = this.completedSteps[index];
    });
  }
  logAndCheck(i: number): boolean {
    return i + 1 < this.currentActive;
  }
  
    get activeStep(): CommonProgressStepComponent {
    return this.progressSteps[this.currentActive - 1];
  }

  private get progressSteps(): CommonProgressStepComponent[] {
    return this.activeSteps.toArray();
  }
  onCancel() {
    if (this.data.importVendorParts) {
      this.importDocumentsService.closeTab('Import Vendor Parts')
      if (this.tabsService?.isOemAndVpl) {
        this.router.navigate([RoutePath.VENDOR_PARTS_LIBRARY]);
        const item: Menu = { path: Path.VENDOR_PART_LIBRARY, title: 'Vendor Parts Library' }
        this.tabsService.addTab(item)
      } else {
        this.router.navigate([RoutePath.PARTLIST_ROUTEPATH]);
        const item: Menu = { path: Path.PARTLIST, title: 'Parts List' }
        this.tabsService.addTab(item)
      }
    }
    else if (this.data.importOEMExcess) {
      this.importDocumentsService.closeTab('Import OEM Excess')
      if (this.tabsService?.isOemAndVpl) {
        this.router.navigate([RoutePath.OEM_EXCESS]);
        const item: Menu = { path: Path.OEM_EXCESS_MANAGER, title: 'OEM Excess Manager' }
        this.tabsService.addTab(item)
      } else {
        this.router.navigate([RoutePath.PARTLIST_ROUTEPATH]);
        const item: Menu = { path: Path.PARTLIST, title: 'Parts List' }
        this.tabsService.addTab(item)
      }

    }
    else if (this.data.importConsignment) {
      this.router.navigate([RoutePath.PARTLIST_ROUTEPATH]);
      this.importDocumentsService.closeTab('Import Consignment')
      const item: Menu = { path: Path.PARTLIST, title: 'Parts List' }
      this.tabsService.addTab(item)
    }
    else if (this.data.importInventory) {
      this.router.navigate([RoutePath.PARTLIST_ROUTEPATH]);
      this.importDocumentsService.closeTab('Import Inventory')
      const item: Menu = { path: Path.PARTLIST, title: 'Parts List' }
      this.tabsService.addTab(item)
    } 
    else if (this.data.importBOM) {
      this.router.navigate([RoutePath.REQUIREMENT_ROUTEPATH]);
      this.importDocumentsService.closeTab()
      const item: Menu = { path: Path.PARTLIST, title: 'Parts List' }
      this.tabsService.addTab(item)
    }
    else {
      this.router.navigate([RoutePath.PARTLIST_ROUTEPATH]);
      this.importDocumentsService.closeTab('Import Part')
      const item: Menu = { path: Path.PARTLIST, title: 'Parts List' }
      this.tabsService.addTab(item)
      this.tabsService.currentTab.next(this.tabName.PARTLIST)
    }
  }

handleClick() {
  // Validate required columns are mapped on Map tab
  if (this.currentActive === 2) {
    // Check if canProceed is explicitly false
    if (this.data?.mapData?.canProceed === false) {
      const unmappedRequiredCount = this.getUnmappedRequiredColumnsCount();
      this.toaster.error(`Please map all required columns (${unmappedRequiredCount} remaining)`);
      return;
    }
  }
  
  this.isDisabled = true;  
  this.onNext.emit(this.currentActive); 
  this.performAction().finally(() => {
    this.isDisabled = false;  
  });
}

async performAction() {
  return new Promise((resolve) => setTimeout(resolve, 1000)); 

}
onCurrentTab(){
  if(!this.data?.errorData?.rowData?.length &&
    !this.data?.errorData?.duplicateData?.rowData?.length
  ){
    this.onPrevClick()
  }else{
    this.data.errorData.isDuplicate = false
  }
}

  get unmappedSystemColumnsCount(): number {
    return this.data?.mapData?.rowData?.filter((row: any) => !row.mappedColumn)?.length ?? 0;
  }

  getUnmappedRequiredColumnsCount(): number {
    return this.data?.mapData?.rowData?.filter((row: any) => 
      row.isRequired && !row.mappedColumn
    )?.length ?? 0;
  }

  isNextButtonDisabled(): boolean {
    if (this.currentActive === 1) {
      const importData = this.data?.importData;
      if (!importData) return true;
      if (importData.buttonDisabled || importData.errorMessageSupported || importData.fileNotMatchError || importData.emptyFile || importData.headerValue) {
        return true;
      }
      if (!importData.uploadSuccess) {
        return true;
      }
      if (this.data.importConsignment) {
        return !importData.consignorId || !importData.contactId;
      } else if (this.data.importOEMExcess) {
        return !importData.customerId || !importData.contactId;
      } else if (this.data.importInventory) {
        return !importData.companyId || !importData.contactId;
      } else if (this.data.importVendorParts) {
        return !importData.vendorId || !importData.contactId;
      }
      return false;
    }
    // Disable Next button on Map tab if required fields are not mapped
    if (this.currentActive === 2) {
      return this.data?.mapData?.blockImport === true || this.data?.mapData?.canProceed === false;
    }
    return this.isDisabled;
  }

  openUnmappedModal(): void {
    const unmapped = this.data?.mapData?.unmappedUploadedColumns;
    if (unmapped?.length) {
      const unmappedColumnsData = unmapped.map((column: string) => ({ systemColumn: column }));
      const modalData = { unmappedColumns: unmappedColumnsData };
      this.sendDataService.openModalPopup(
        UnmappedPopUpComponent,
        modalData,
        'Unmapped Headers',
        ModalPopupSize.LG,
        'markAsAddEditAddress has-parent-popup'
      );
    }
  }
}
